import { gql } from '@apollo/client';

const BAG_DETAIL_PAGE_BODY = `
      content {
        bagNumber
        taskNumber
        taskDate
        plannedDepartureTime
        actualDepartureTime
        arrivalStatus
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
`;

// 仅用于本仓发出（OUTBOUND）视角，后端按 fromHubId 校验仓库权限
export const GET_INHUB_TRANSPORT_BAG_DETAIL_PAGE = gql`
  query GetInhubTransportBagDetailPage($filter: InhubTransportDetailInput!) {
    getInhubTransportBagDetailPage(filter: $filter) {
      ${BAG_DETAIL_PAGE_BODY}
    }
  }
`;

// 本仓到达（INBOUND）视角专用，后端按 toHubId 校验仓库权限
export const GET_INHUB_TRANSPORT_INBOUND_BAG_DETAIL_PAGE = gql`
  query GetInhubTransportInboundBagDetailPage($filter: InhubTransportDetailInput!) {
    getInhubTransportInboundBagDetailPage(filter: $filter) {
      ${BAG_DETAIL_PAGE_BODY}
    }
  }
`;

export type InhubTransportDetailStatusFilter = 'DEPARTED' | 'ARRIVED' | 'NOT_ARRIVED' | 'OVER_72H';

export type InhubTransportBagArrivalStatus = 'ARRIVED' | 'NOT_ARRIVED_WITHIN_72H' | 'NOT_ARRIVED_OVER_72H';

export interface InhubTransportDetailInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
    fromHubId: number | null;
    toHubId: number | null;
    statusFilter: InhubTransportDetailStatusFilter;
    page?: number;
    pageSize?: number;
}

export interface InhubTransportBagDetailRowResp {
    bagNumber: string;
    taskNumber: string | null;
    taskDate: string | null;
    plannedDepartureTime: string | null;
    actualDepartureTime: string | null;
    arrivalStatus: InhubTransportBagArrivalStatus;
}

export interface InhubTransportBagDetailPageResp {
    content: InhubTransportBagDetailRowResp[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

// 两个视角各自独立的 operation，抽屉按当前视角二选一，故两个 key 均为可选
export interface GetInhubTransportBagDetailPageResponse {
    getInhubTransportBagDetailPage?: InhubTransportBagDetailPageResp;
    getInhubTransportInboundBagDetailPage?: InhubTransportBagDetailPageResp;
}
